import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const clearPayPalErrors: CheckoutActionCreator = () => (dispatch) => {
  dispatch({
    type: actionTypes.CHECKOUT_PAYPAL_ERRORS_CLEAR,
  })
}
